/** Parse parent SKU from Simple Bundles title metadata (Shopify custom attribute / ShipStation option). */
export function parseParentSkuFromBundleTitle(title: string | null | undefined): string | null {
  if (!title || typeof title !== 'string') return null;
  const match = title.match(/SKU:\s*([^\s|]+)/i);
  return match ? match[1].trim() : null;
}

/** Display name is the portion before "| SKU:" in the bundle title string. */
export function parseParentDisplayNameFromBundleTitle(title: string | null | undefined): string | null {
  if (!title || typeof title !== 'string') return null;
  const pipeIdx = title.search(/\|\s*SKU:/i);
  const raw = pipeIdx >= 0 ? title.slice(0, pipeIdx).trim() : title.trim();
  return raw || null;
}
